import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    
	
	
   if(sessionStorage.getItem("OtherLotEntry_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    setId("{Auto}");
    setLotNo("{Auto}");

	//Clear();
   
   }
   else if(sessionStorage.getItem("OtherLotEntry_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("OtherLotEntry_EditId"));
   }
   else if(sessionStorage.getItem("OtherLotEntry_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("OtherLotEntry_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  GetGrnDetails1();
  }

  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtSmith, setdtSmith]=useState([]);
  const [dtProd, setdtProd]=useState([]);
  const [dtSubProd, setdtSubProd]=useState([]);
  const [dtGrnDetails, setdtGrnDetails]=useState([]);
  const [dtGrnDetailsOrg, setdtGrnDetailsOrg]=useState([]);
 

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  
   const [LotType, setLotType,LotTypeRef] = useStateRef('Normal');
   const [Id, setId, IdRef] = useStateRef(0);
   const [LotDate, setLotDate, LotDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   const [ProdCode, setProdCode, ProdCodeRef] = useStateRef(0);
   const [SmithCode, setSmithCode, SmithCodeRef] = useStateRef(0);
   const [SubCode, setSubCode, SubCodeRef] = useStateRef(0);
   const [GrnNo, setGrnNo, GrnNoRef] = useStateRef(0);
   const [RepairNo, setRepairNo, RepairNoRef] = useStateRef(0);

   const [Pcs, setPcs, PcsRef] = useStateRef(0);
   const [DiaWt, setDiaWt, DiaWtRef] = useStateRef(0);
   const [DiaPcs, setDiaPcs, DiaPcsRef] = useStateRef(0);
   const [GrossWt, setGrosswt, GrossWtRef] = useStateRef(0);
   const [NetWt, setNetWt, NetWtRef] = useStateRef(0);
   const [StonePcs, setStonePcs, StonePcsRef] = useStateRef(0);
   const [StoneWt, setStoneWt, StoneWtRef] = useStateRef(0);
   const [LotNo, setLotNo, LotNoRef] = useStateRef(0);

   const [LabelTxt, setLabelTxt, LabelTxtRef] = useStateRef('GRN No');
   const [SearchTxt, setSearchTxt, SearchTxtRef] = useStateRef('');


function SearchFun(text)
{
  setdtGrnDetails(dtGrnDetailsOrg.filter(function (x) {
    return x.No.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  

 
  async function Clear()
   {
        

		handleClose1();
		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



function Calc()
{
  
  

}


async function ControlSettings()
{

  document.getElementById("txtLotNo").disabled ='true';
  
  
  if((sessionStorage.getItem("OtherLotEntry_Action")=="Edit") || (sessionStorage.getItem("OtherLotEntry_Action")=="Delete"))
   {
  
    document.getElementById("txtLotType").disabled ='true';
    

   }

 



}



async function GetGrnDetails1()
{
  try
  {
   
    let postData = {
      "LotType":LotTypeRef.current
  }

  const results = await apiService.postCall("OtherLotEntry/GetGrnDetails1",postData);

 if (results != "-1") {
   setdtGrnDetails(results.data[0]);
   setdtGrnDetailsOrg(results.data[0]);
 }

  
  }
  catch (error) {
    console.log(error);
  }
}


async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("OtherLotEntry/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   

   getLookup();



      setLotType(HeadData[0][0].LotType);
      setId(HeadData[0][0].id);
     	setSmithCode(HeadData[0][0].SmithCode);
      setProdCode(HeadData[0][0].ProdCode);
      setSubCode(HeadData[0][0].SubCode);
      setGrnNo(HeadData[0][0].GrnNo);
      setPcs(HeadData[0][0].Pcs);
      setGrosswt(HeadData[0][0].Grosswt);
      setNetWt(HeadData[0][0].NetWt);
      setStonePcs(HeadData[0][0].StonePcs);
      setStoneWt(HeadData[0][0].StoneWt);
      setDiaPcs(HeadData[0][0].Diapcs);
      setDiaWt(HeadData[0][0].DiaWt);
      setLotDate(HeadData[0][0].Date.substring(0,10));
      setLotNo(HeadData[0][0].LotNo);
     

      if(LotTypeRef.current=='Normal')
        setLabelTxt("GRN No");
      else
        setLabelTxt("Repair No");

        GetGrnDetails1();
   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
			
			if(GrnNoRef.current=="0")
      {
 
        swal({

          title: "",
          text: "Please Select GRN No or Repair No",
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
    
        return;
      }
	
		 
		let postData = {
			"Action" : sessionStorage.getItem("OtherLotEntry_Action"),
			"EditId" : sessionStorage.getItem("OtherLotEntry_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"LotType": LotTypeRef.current,
      "SmithCode": SmithCodeRef.current,
      "ProdCode": ProdCodeRef.current,
			"SubCode": SubCodeRef.current,
      "LotDate": LotDateRef.current,
      "GrnNo": GrnNoRef.current,
      "Pcs": PcsRef.current,
      "GrossWt": GrossWtRef.current,
      "NetWt": NetWtRef.current,
      "StonePcs": StonePcsRef.current,
      "StoneWt": StoneWtRef.current,
      "DiaPcs": DiaPcsRef.current,
      "DiaWt": DiaWtRef.current,
      "LotType": LotTypeRef.current,
    }

    

   const results = await apiService.postCall("OtherLotEntry/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("OtherLotEntry_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("OtherLotEntry_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("OtherLotEntry_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  async function setCheck(id)
  {

    try
  {
   setGrnNo(id);

   
  
    let postData = {
      "GRNNo": GrnNoRef.current,
      "LotType":LotTypeRef.current
  }

  const results = await apiService.postCall("OtherLotEntry/GetGrnDetails",postData);

 if (results != "-1") {
  
  if(postData.LotType=="Repair")
  {
   
    setProdCode(results.data[0][0].ProdCode);
    setSubCode(results.data[0][0].subcode);
    setPcs(results.data[0][0].Pcs);
    setGrosswt(results.data[0][0].GrossWt);
    setNetWt(results.data[0][0].GrossWt);
    
  }
  else
  {
    setSmithCode(results.data[0][0].acccode)
    setPcs(results.data[0][0].Pcs);
    setGrosswt(results.data[0][0].GrossWt);
    setNetWt(results.data[0][0].NetWt);

  }

 }

 setTMShow1(false);

  
  }
  catch (error) {
    console.log(error);
  }

   


}



  async function getsubProd(){
    try {
     
      
      
     let postData = {
      "ProdCode" : ProdCodeRef.current
     };
     
  
    const results = await apiService.postCall("OtherLotEntry/getsubProd",postData);
 
    if (results != "-1") {
      setdtSubProd(results.data[0]);
     }
} catch (error) {
       console.log(error);
     }
 }

  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : ProdCodeRef.current
    };
		
    const results = await apiService.postCall("OtherLotEntry/Lookup",postData);

	 if (results != "-1") {

    setdtSmith(results.data[0][0]);
    setdtProd(results.data[1][0]);
    setdtSubProd(results.data[2][0]);
		 
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/plussing/OtherLotEntry/list');
  };

  return (
    <>
    

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Other Lot Entry Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>


                        <div className='col-md-12'>
                            <Form.Label>Lot Type</Form.Label>
                             <select className="form-select" id="txtLotType" value={LotType} onChange={(e)=>
                              {
                                setLotType(e.target.value)

                                if(LotTypeRef.current=="Normal")
                                { setLabelTxt("GRN No")}
                                else
                                { setLabelTxt("Repair No")}

                                GetGrnDetails1()
                                
                                }
                                } disabled={false}>
              								<option value='Normal'>Normal</option>
                              <option value='Repair'>Repair</option>
              							 </select>
                          </div>


                          <div className='col-md-6'>
                            <Form.Label>Lot No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtLotNo" placeholder="" value={LotNo}  />
                          </div>
                         
                          <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtLotDate" placeholder="" value={LotDate} onChange={(e)=>setLotDate(e.target.value)} />
                          </div>
						  

                          <div className='col-md-12'>
                            <Form.Label>Smith</Form.Label>
                            <Select className="form-select-search" isSearchable={true} 
                                          value={dtSmith.filter(function(option) {
                                             return option.value === SmithCode;
                                           })}
                                          options={dtSmith}
                                          id="txtSmith"  
                                          onChange=
                                          {
                                             (e) => {
                                              setSmithCode(e.value)
                                             
                                             }
                                             } >

                            </Select>

                          
                          </div>



                          <div className='col-md-4'>
   <Form.Label><a onClick = {(e) => setTMShow1(true)} href="#">{LabelTxt}</a></Form.Label>
   <Form.Control type="text" id="txtGrnNo" readOnly="Readonly" placeholder="" value={GrnNo} onChange={(e)=> 
   {
    setGrnNo(e.target.value)
   }
  }  />

 
 </div>


 
                          <div className='col-md-12'>
                            <Form.Label>Product</Form.Label>

                            <Select className="form-select-search" isSearchable={true} 
                                          value={dtProd.filter(function(option) {
                                             return option.value === ProdCode;
                                           })}
                                          options={dtProd}
                                          id="txtProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setProdCode(e.value)
                                              getsubProd()
                                             }
                                             } >

                            </Select>

                          </div>


                          <div className='col-md-12'>
                            <Form.Label>Sub Product</Form.Label>

                            <Select className="form-select-search" isSearchable={true} 
                                          value={dtSubProd.filter(function(option) {
                                             return option.value === SubCode;
                                           })}
                                          options={dtSubProd}
                                          id="txtSubProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setSubCode(e.value)
                                             
                                             }
                                             } >

                            </Select>

                            
                          </div>


 

   </div>
	  </div>
</div>

</div>

<div className='col-lg-6'>
<div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
<div className='row py-2'>
                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text"  id="txtPcs" placeholder="" value={Pcs} onChange={(e)=>setPcs(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" id="txtGrossWt" placeholder="" value={GrossWt} onChange={(e)=>setGrosswt(e.target.value)} />
                          </div>
                          <div className='col-md-4'>
                            <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="text" id="txtNetWt" placeholder="" value={NetWt} onChange={(e)=>setNetWt(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Stone Pcs</Form.Label>
                            <Form.Control type="text" id="txtStonePcs" placeholder="" value={StonePcs} onChange={(e)=>setStonePcs(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Stone Wt</Form.Label>
                            <Form.Control type="text" id="txtStoneWt" placeholder="" value={StoneWt} onChange={(e)=>setStoneWt(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Dia Pcs</Form.Label>
                            <Form.Control type="text" id="txtDiaPcs" placeholder="" value={DiaPcs} onChange={(e)=>setDiaPcs(e.target.value)} />
                          </div>
                          
                          <div className='col-md-4'>
                            <Form.Label>Dia Wt</Form.Label>
                            <Form.Control type="text" id="txtDiaWt" placeholder="" value={DiaWt} onChange={(e)=>setDiaWt(e.target.value)} />
                          </div>



                        </div>
                        </div>
                        </div>

</div>
                  </div>
                 
              </div>
             

                 
             
           
			  
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg"  id ="otherlotentrytableModal" >
                  <Modal.Header closeButton>
                    <Form.Control type="text" placeholder='Search' value={SearchTxt} onChange={(e)=> { 
                      setSearchTxt(e.target.value)
                      SearchFun(e.target.value)
                      }}/>
                  </Modal.Header>

                  <Modal.Body>
                    
                                 
              <div className="table-responsive mt-4" id="otherlotentrytable1" >
			 
				
       <Table striped id="table-basic" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>{LabelTxt}</th>
             <th>Pcs</th>
             <th>GrossWt</th>   
             <th>NetWt</th>              
             
           </tr>
         </thead>
         <tbody>
         {dtGrnDetails.map((item) => (
           <tr>
            
   <td>  
    
     <Form.Check className="me-2">
                               
                               <Form.Check.Input type="radio" name="g1" onChange={(e) => setCheck(item.No)} checked={item.checked} className="lstItems" id={item.GrnNo} />
                               
                               <Form.Check.Label>{item.No}</Form.Check.Label>
                             </Form.Check>
                             </td>
         
             
             <td>{item.Pcs}</td>
             <td>{item.GrossWt}</td>
             <td>{item.NetWt}</td>
            


           </tr>
             )
             )
              }     
         </tbody>
       </Table>
      
     </div>

					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
